import { createApp } from 'vue'
// import { createPinia } from 'pinia'
// import { configuration, setupAirbrake, dataLayer, privacy, authentication, config } from '@dpgradio/creative'
// import { Notifier as AirbrakeNotifier } from '@airbrake/browser'
import './style.css'
import App from './App.vue'

const initialize = async () => {
  // try {
  //   await configuration.retrieveConfigForDetectedStation('application-name')
  // } catch (error) {
  //   alert(`
  //     Could not load configuration.
  //     - Have you set up a configuration for this application in Dario (see [updateConfigSchema.js])? If you do not want a custom configuration, remove the application name from the [configuration.retrieveConfigForDetectedStation] call in [main.js].
  //     - Did you provide a station name? (e.g. through the URL parameter 'stationId') If you want to set the station name in code, replace the configuration retrieval call with [configuration.retrieveConfigForStation('<station-name>', 'application-name')] in [main.js].

  //     ${error}
  //   `)
  // }

  // Set document language from config
  // const language = config('language')
  // if (language) {
  //   document.documentElement.lang = language
  // }

  // authentication.initialize()

  // const pinia = createPinia()
  const app = createApp(App)

  // if (import.meta.env.PROD) {
  //   await setupAirbrake(
  //     AirbrakeNotifier,
  //     {
  //       projectId: '<project-id>',
  //       projectKey: '<project-key>',
  //       version: import.meta.env.VITE_COMMIT_HASH,
  //     },
  //     app
  //   )
  // }

  // app.use(pinia)
  app.mount('#app')

  // privacy.initialize()
  // dataLayer.initialize()
  // dataLayer.pushVirtualPageView()
}

window.createVueApp = () => initialize()
window.createVueApp()
